import React, { useCallback } from 'react';
import { useFocusEffect } from '@react-navigation/native';
import { useShallow } from 'zustand/react/shallow';
import { PosRecargaModal } from './PosRecargaModal';
import { usePosOverlayStore } from '../../store/usePosOverlayStore';
import { usePosCashSessionStore } from '../../store/usePosCashSessionStore';
import { useBranchPermission } from '../../../shell/session/hooks/useBranchPermission'
import { useHasBusinessCapability } from '../../../shell/session/hooks/useEffectiveBusinessCapabilities'
import { useSessionStore } from '../../../shell/session/store/useSessionStore';
import { usePosRecarga } from '../../screens/hooks/usePosRecarga';
import { consumePosNavigationIntent } from '../../application/posNavigationIntent';

export const PosRecargaModalContainer = () => {
  const { canEdit, actions } = useBranchPermission('POS');
  const allowsExternalServices = useHasBusinessCapability('external_services');
  const canExternalServices = actions?.external_services !== false;
  const currentBranchId = useSessionStore((s) => s.currentBranchId);
  const activeCashSessionId = usePosCashSessionStore((s) => s.activeCashSessionId);

  const {
    recargaVisible,
    recargaType,
    recargaAmount,
    recargaReference,
    recargaPaymentMethod,
  } = usePosOverlayStore(
    useShallow((s) => ({
      recargaVisible: s.recargaVisible,
      recargaType: s.recargaType,
      recargaAmount: s.recargaAmount,
      recargaReference: s.recargaReference,
      recargaPaymentMethod: s.recargaPaymentMethod,
    })),
  );

  const setRecargaVisible = usePosOverlayStore((s) => s.setRecargaVisible);
  const setRecargaType = usePosOverlayStore((s) => s.setRecargaType);
  const setRecargaAmount = usePosOverlayStore((s) => s.setRecargaAmount);
  const setRecargaReference = usePosOverlayStore((s) => s.setRecargaReference);
  const setRecargaPaymentMethod = usePosOverlayStore((s) => s.setRecargaPaymentMethod);
  const closeRecarga = usePosOverlayStore((s) => s.closeRecarga);

  const { saving, saveRecarga } = usePosRecarga({
    canEdit: canEdit && canExternalServices,
    currentBranchId,
    activeCashSessionId,
    serviceType: recargaType,
    amount: recargaAmount,
    reference: recargaReference,
    paymentMethod: recargaPaymentMethod,
    closeRecarga,
  });

  useFocusEffect(
    useCallback(() => {
      if (!allowsExternalServices) return;
      const intent = consumePosNavigationIntent();
      if (intent?.openRecarga) {
        setRecargaVisible(true);
      }
    }, [allowsExternalServices, setRecargaVisible]),
  );

  if (!allowsExternalServices) return null;

  return (
    <PosRecargaModal
      visible={recargaVisible}
      serviceType={recargaType}
      amount={recargaAmount}
      reference={recargaReference}
      paymentMethod={recargaPaymentMethod}
      onClose={closeRecarga}
      onChangeServiceType={setRecargaType}
      onChangeAmount={setRecargaAmount}
      onChangeReference={setRecargaReference}
      onChangePaymentMethod={setRecargaPaymentMethod}
      onSave={saveRecarga}
      saving={saving}
    />
  );
};
